import React from 'react';
type CtaButtonProps = {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
};
export function CtaButton({
  href,
  children,
  size = 'lg',
  fullWidth = false
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'min-h-[4rem] px-7 py-4 text-xl sm:px-9 sm:text-2xl' : 'min-h-[3.5rem] px-6 py-3 text-lg';
  return <a href={href} className={`inline-flex max-w-full items-center justify-center rounded-xl bg-cta text-center font-sans font-bold uppercase leading-tight text-white shadow-[0_6px_0_#15803D,0_16px_32px_-12px_rgba(34,197,94,0.45)] transition-[transform,background-color,box-shadow] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:translate-y-0.5 hover:bg-cta-hover hover:shadow-[0_4px_0_#15803D,0_12px_24px_-12px_rgba(34,197,94,0.45)] active:translate-y-[6px] active:shadow-none focus:outline-none focus-visible:ring-4 focus-visible:ring-gold focus-visible:ring-offset-2 sm:whitespace-nowrap ${sizeClasses} ${fullWidth ? 'w-full' : ''}`} data-id="element-282" data-mp="20w556vo79fpt">
      {children}
    </a>;
}